import React, { Fragment } from 'react';
import PropTypes from 'prop-types'

// Redux
import { connect } from 'react-redux';

// Actions
import { updateLanguage } from '../../actions/authActions';

// Icons
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';

// Utils
import { LANGUAGE_LIST } from '../../util/Languages_List';
  
const Config_Block = ({
    auth: {
        user
    },
    updateLanguage
}) =>  {
	return (
        <Fragment>
            {/* Avaible credits block */}
            <div>
                <h3 style={{marginBottom: '1.5rem', fontSize: '1.25rem', color: '#fff'}}>
                    Credits
                </h3>
                <p style={{color: 'rgb(152,152,152)', fontSize: '15px', fontWeight: 500}}>
                    Purchase additional credits to use Interview Cheater
                </p>
                <div style={{padding: '1.5rem', background: 'rgb(39,39,42,.3)', border: '1px solid rgb(39,39,42)', borderRadius: '.75rem'}}>
                    <p style={{color: 'rgb(255,255,255)', fontSize: '1rem', lineHeight: '1.25rem', margin: '0 0 .5rem'}}>
                        Available Credits
                    </p>
                    <h2 style={{color: 'rgb(228,228,231)', fontWeight: 'bold', fontSize: '2rem', margin: 0}}>
                        UNLIMITED
                    </h2>
                    <p style={{color: 'rgb(212,212,216)', fontSize: '.875rem', lineHeight: '1.25rem', marginTop: '.5rem'}}>
                        Credits reset back to unlimited at the start of each billing cycle
                    </p>
                </div>

            </div>

            {/* Language Settings block */}
            <div>
                <h3 style={{marginBottom: '1.5rem', fontSize: '1.25rem', color: '#fff'}}>
                    Language Settings
                </h3>
                <p style={{color: 'rgb(152,152,152)', fontSize: '15px', fontWeight: 500}}>
                    Choose your preferred programming language for code generation
                </p>
                <div style={{padding: '1.5rem', background: 'rgb(39,39,42,.3)', border: '1px solid rgb(39,39,42)', borderRadius: '.75rem'}}>
                    {/* Dropwdown menu */}
                    <div style={{marginRight:'12px', maxWidth: '300px', cursor:'pointer', position: 'relative', flexGrow: 2, backgroundColor:'#000', borderRadius:'4px', border: '1px solid rgb(39,39,42)'}}>
                        <label style={{lineHeight:'16px', fontSize:'13px', paddingTop:'8px', color:'#fff', position:'absolute', overflowWrap: 'break-word', paddingLeft:'8px', paddingRight:'8px'}}>
                            <span>Current Language</span>
                        </label>
                        <select 
                            name="languages" 
                            value={user?.default_language} 
                            onChange={(e) => updateLanguage(e.target.value)} 
                            style={{width:'100%', paddingLeft:'8px', paddingRight:'8px', paddingTop:'12px', lineHeight:'20px', outline:'none', border:'none', backgroundColor:'rgba(0, 0, 0, 0)', appearance:'none', outlineStyle:'none', color:'#fff', fontSize:'17px', marginTop:'16px', paddingBottom:'8px', cursor:'pointer'}}
                        >
                            {LANGUAGE_LIST.map((language) => {
                                return <option value={language} style={{color: '#000'}}>{language}</option>;
                            })}
                        </select>
                        <KeyboardArrowDownOutlinedIcon style={{top: '50%', right:'12px', marginTop:'-0.75em', height:'1.5em', color:'#fff', position:'absolute'}} />
                    </div>
                    <p style={{color: 'rgb(212,212,216)', fontSize: '.875rem', lineHeight: '1.25rem', marginTop: '.5rem'}}>
                        This will be used as the default language for your code generation
                    </p>
                </div>

            </div>

        </Fragment>
	);
}
  
Config_Block.propTypes = {
    // Prop type validation for authentication
    auth: PropTypes.object.isRequired,
    updateLanguage: PropTypes.func.isRequired,
}

const mapStateToProps = state => ({
    // Mapping the authentication state
    auth: state.auth
});

export default connect(mapStateToProps, { 
    // Connecting actions to the component
    updateLanguage
})(Config_Block);
  
  